
import Vue from "vue";

export default Vue.extend({
  name: "RecruiterAiCandidateCard",
  props: {
    candidateName: {
      type: String,
      required: true
    },
    candidateRole: {
      type: String,
      required: true
    },
    avatarUri: {
      type: String,
      required: true
    },
    coverImage: {
      type: String,
      required: true
    }
  }
});
